import { BlockUI, NgBlockUI }       from 'ng-block-ui';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }         from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { MessagesService } from '../messages/messages.service';
import { SmsCostModel }    from './models/sms-cost';
import { SmsPurchase }     from './models/sms-purchase';

@Component({
  selector   : 'wor-buy-sms',
  template: require('./company.buy-sms.component.html')
})
export class BuySmsComponent implements OnInit {
  public isPurchasing = false;

  totalCost = 0;

  @BlockUI('buySmsBlock') block : NgBlockUI;

  @Input() cost : SmsCostModel;
  @Input() count: number;

  purchase : SmsPurchase;

  constructor (
    public activeModal      : NgbActiveModal,
    private apiService      : ApiService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.purchase = {
      agree   : false,
      cost    : this.cost,
      quantity: 0
    };
  }

  calculateCost ( quantity = this.purchase.quantity ) : void {
    if (quantity < 500) {
      this.totalCost = this.purchase.cost.high_sms_price * quantity;
    }
    else if (quantity >= 500 && quantity < 5000) {
      this.totalCost = this.purchase.cost.medium_sms_price * quantity;
    }
    else {
      this.totalCost = this.purchase.cost.low_sms_price * quantity;
    };
  }

  confirm () : void {
    this.block.start();

    this.isPurchasing = true;

    this.apiService.get('/sms_logs/purchase', [ this.purchase.agree, this.purchase.quantity ])
    .then(() => this.apiService.get('/sms_logs/current_sms_count'))
    .then(( count : number ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PURCHASE_SUCCESSFUL'), 'success');

      this.activeModal.close(count);
    })
    .catch(err => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();

      this.isPurchasing = false;
    });
  }
}